export const periodToText = {
  NONE: '',
  P1H: 'Hourly',
  P1D: 'Daily',
  P7D: 'Weekly',
  P1M: 'Monthly',
};
